import './style.css'
import GSAP from 'gsap'

//init experience
import Experience from './Experience/Experience'
const experience = new Experience(document.querySelector('canvas.webgl'))

//Variables
const button = document.querySelector('.decouvrir')
const main = document.querySelector('main')
const label = document.querySelector('.label')
const modalStand = document.querySelector('.modal-stand')

//controls toggle audio
const playStop = document.querySelector('.playStop')
const audio = document.querySelector('audio')
playStop.addEventListener('click', () => {
  if (audio.paused && audio.currentTime > 0 && !audio.ended) {
    audio.play()
    if (playStop.classList.contains('playStopInactive')) {
      playStop.classList.remove('playStopInactive')
    }
  } else {
    audio.pause()
    playStop.classList.add('playStopInactive')
  }
})

//Main button decouvrir
button.addEventListener('click', () => {
  GSAP.to(label, { autoAlpha: 1 })
  GSAP.to(main, { scale: 1.2, autoAlpha: 0, duration: 0.5, ease: 'Power1.easeOut' })
  GSAP.to(button, { autoAlpha: 0 })

  //Audio
  audio.muted = false
  audio.volume = 0.2
  audio.play()
})

//Button label
label.addEventListener('click', () => {
  GSAP.to(modalStand, { right: '0%', duration: 1.2, ease: 'Power1.easeOut' })
})
//Close Modal
modalStand.addEventListener('click', () => {
  GSAP.to(modalStand, { right: '-100%', duration: 1.2, ease: 'Power1.easeOut' })
})
